import { QList } from "./QList";

export class QFramelessDropDownList extends QList {
  constructor() {
    super();
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var srcElement = aCmd.GetSourceElement();
    aCmd.fSourcePanel = aCmd.fSourcePanel.fBackgroundPanel;
    var srcPanel = aCmd.GetSourcePanel();

    var panelHandled = false;
    var doUpdateDropDown = true;
    var cmdProcessor = cmdCode.split("-");
    if (cmdProcessor.length > 1 && cmdProcessor != cmdCode) {
      cmdCode = cmdProcessor.shift();
      var subCode = cmdProcessor.join("-");
      aCmd["newvalue"] = subCode;
    }
    var dataSource = this.fDataSource;
    switch (cmdCode) {
      case "toggleOption":
        var targetOption = srcElement.fName;
        var targetOptionIndex = dataSource.findIndex(
          sourceItem => JSON.stringify(sourceItem) === JSON.stringify(targetOption)
        );

        if (targetOptionIndex >= 0) dataSource.splice(targetOptionIndex, 1);
        else dataSource.push(targetOption);

        break;
    }

    if (doUpdateDropDown) {
      srcPanel.DoUpdateFramelessToggleArray();
    }

    return panelHandled;
  }
}
